<template>
    <v-app class="white">
        <v-navigation-drawer
                app
                clipped
                hide-overlay
                v-model="drawer">
            <v-list tile nav flat active-class="">
                <v-list-item to="/home/general">
                    <v-list-item-avatar tile>
                        <img v-bind:src="userInfo.logo" class="small-logo"/>
                    </v-list-item-avatar>
                    <v-list-item-title class="page">{{userInfo.title}}</v-list-item-title>
                </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list dense class="pt-0" nav>
                <v-list-item v-for="item in items" :key="item.title" :to="item.path" :target="item.target"
                             v-show="item.adminOnly ? userInfo.admin :true">
                    <v-list-item-action>
                        <v-icon>{{item.icon}}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="page">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar dark app clipped-left>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

            <v-toolbar-title class="headline text-uppercase">
                <span>ЧЕМПИОНАТ МИРА</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn target="_blank">
                <span class="mr-2" @click="logOut">Выйти</span>
            </v-btn>
        </v-app-bar>
        <v-content>
            <v-container fluid class="pa-8">
                <router-view
                        v-bind:userInfo="userInfo"
                        v-bind:teams="teams"
                        v-bind:prevMatchday="prevMatchday"
                        v-bind:matchday="matchday"
                        v-bind:players="players"
                        v-bind:loaded="loaded"
                        v-bind:currentRoster="currentRoster"/>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import firebase from "firebase";

    export default {
        data() {
            return {
                userInfo: {
                    title: "",
                    logo: "",
                    admin: true
                },
                teams: [],
                currentRoster: null,
                players: [],
                drawer: true,
                prevMatchday: null,
                matchday: null,
                loaded: false,
                items: [
                    {
                        title: "Мой состав",
                        icon: "format_list_numbered",
                        path: "/home/roster",
                    },
                    {
                        title: "Составы",
                        icon: "view_carousel",
                        path: "/home/teams"
                    },
                    {
                        title: "Результаты",
                        icon: "assessment",
                        path: "/home/results"
                    },
                    {
                        title: "Форум Форварда",
                        icon: "forum",
                        path: "/home/forum",
                        target: "_blank"
                    },
                    {
                        title: "Администрирование",
                        icon: "assessment",
                        path: "/home/admin",
                        adminOnly: true
                    },
                ]
            };
        },
        methods: {
            logOut: function () {
                firebase
                    .auth()
                    .signOut()
                    .catch(function (error) {
                        alert(error.message);
                    });
            },
            getCurrentRoster() {
                firebase
                    .firestore()
                    .collection("rosters")
                    .where("team", "==", firebase.auth().currentUser.uid)
                    .orderBy("matchday", 'desc')
                    .limit(1)
                    .onSnapshot({
                        next: rosterSnapshot => {
                            this.currentRoster = rosterSnapshot.docs[0].data().roster
                        }
                    })
            },
            getRoster(team) {
                firebase
                    .firestore()
                    .collection("rosters")
                    .where("team", "==", team.id)
                    .where("matchday", "<", parseInt(this.matchday))
                    .orderBy("matchday", 'desc')
                    .limit(1)
                    .onSnapshot({
                            next:
                                rosterSnapshot => {
                                    // eslint-disable-next-line no-console
                                    console.log('document reads', rosterSnapshot.size);

                                    this.roster = rosterSnapshot.docs[0];
                                    if (rosterSnapshot.size) {

                                        var players = [];
                                        let matchday = rosterSnapshot.docs[0].data().matchday
                                        let roster = rosterSnapshot.docs[0].data().roster;
                                        roster.goalkeepers.forEach(goalkeeper => {
                                            players.push(goalkeeper)
                                        });

                                        roster.fives.forEach(five => {
                                            five.defenders.forEach(defender => {
                                                players.push(defender)
                                            });
                                            five.forwards.forEach(forward => {
                                                players.push(forward)
                                            })
                                        });
                                        this.teams.push({
                                            matchday: matchday,
                                            title: team.title,
                                            players: players
                                        })
                                    }
                                }
                        }
                    )
            },
            getMatchday() {
                return firebase
                    .firestore()
                    .collection("config")
                    .onSnapshot({
                        next: config => {
                            // eslint-disable-next-line no-console
                            console.log('document reads', config.size);
                            this.matchday = config.docs[0].data().matchday;
                            this.prevMatchday = config.docs[0].data().prevMatchday;
                            this.getRosters();
                        }
                    })
            },
            getPlayers(uid) {
                return firebase
                    .firestore()
                    .collection("teams")
                    .doc(uid)
                    .collection("players")
                    .get()
                    .then(snapshot => {
                        // eslint-disable-next-line no-console
                        console.log('document reads', snapshot.size)
                        snapshot.docs.forEach(playerDoc => {
                            this.players.push(playerDoc.data())
                        });
                    });
            },
            getRosters() {
                this.teams = []
                firebase
                    .firestore()
                    .collection("teams")
                    .orderBy("title")
                    .get()
                    .then(teamSnapshot => {
                        // eslint-disable-next-line no-console
                        console.log('document reads', teamSnapshot.size)

                        teamSnapshot.docs.forEach(doc => {
                            if (!doc.data().role) {
                                this.getRoster({
                                    id: doc.id,
                                    title: doc.data().title
                                })
                            }
                        })
                    })
            }
        },
        async mounted() {
            let user = firebase.auth().currentUser;
            firebase
                .firestore()
                .collection("teams")
                .doc(user.uid)
                .get()
                .then(doc => {
                    if (doc.exists) {
                        this.userInfo = doc.data();
                    } else {
                        // doc.data() will be undefined in this case
                    }
                })
                .catch(error => {
                    alert(error.message);
                });


            await Promise.all([this.getMatchday(), this.getPlayers(user.uid)], this.getCurrentRoster());

            this.loaded = true;


        }
    }
    ;
</script>


<style>
    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 20px;
    }

    .logo {
        max-height: 15%;
        max-width: 15%;
        object-fit: scale-down;
    }

    .logo_sm {
        max-height: 40%;
        max-width: 40%;
        object-fit: scale-down;
    }


    .small-logo {
        max-width: 100%;
        max-height: 100%;
        object-fit: scale-down;
    }

    .page {
        text-align: start;
        font-weight: bold;
        color: #2c3e50;
    }
</style>

